<div class="lmo-driver-site-restrictions-list-component">
  <div class="driver-site-restrictions-container">
    <div class="driver-site-restrictions-content">
      <div class="driver-site-restrictions-header flex justify-between items-center gap-1">
        <div class="driver-site-restrictions-title flex flex-row items-center">
          <img src="/assets/icons/restricted.svg" alt="Users" />
          <div class="title">Driver Site Restrictions</div>
        </div>
        <div class="flex flex-row">
          <div class="driver-site-restrictions-filter-carrier flex flex-row items-center">
            <mat-form-field class="example-full-width">
              <mat-label>Filter By Carrier</mat-label>
              <input type="text" matInput [formControl]="filteredCarrierControl" [matAutocomplete]="autoCarrier" />
              <mat-autocomplete #autoCarrier="matAutocomplete" [displayWith]="displayCarrierFn">
                <mat-option *ngFor="let carrier of filteredCarriers | async" [value]="carrier">
                  {{ carrier.carrier_name }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
          <div class="driver-site-restrictions-filter-subcarrier flex flex-row items-center">
            <mat-form-field class="example-full-width">
              <mat-label>Filter By Subcarrier</mat-label>
              <input
                type="text"
                matInput
                [formControl]="filteredSubcarriersControl"
                [matAutocomplete]="autoSubcarrier"
              />
              <mat-autocomplete #autoSubcarrier="matAutocomplete" [displayWith]="displaySubcarrierFn">
                <mat-option *ngFor="let subcarrier of filteredSubcarriers | async" [value]="subcarrier">
                  {{ subcarrier.subcarrier_name }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div>
        <div class="w-full flex flex-row items-center gap-1 mt-3">
          <i class="material-icons">
            search
          </i>
          <mat-form-field class="w-full">
            <input matInput type="text" placeholder="Search Driver" autofocus [formControl]="driverSearchControl" />
          </mat-form-field>
        </div>
        <div class="w-full flex flex-row items-center gap-1 mt-3 relative overflow-x-auto">
          <table class="table-auto drivers-table" (matSortChange)="sortChanged($event)" matSort>
            <thead>
              <tr>
                <th class="table-header" style="width: 300px;" mat-sort-header="name">Name</th>
                <th class="table-header" mat-sort-header="phone">Phone</th>
                <th class="table-header" mat-sort-header="carrier">Carrier</th>
                <th class="table-header" mat-sort-header="subcarrier">Subcarrier</th>
                <th class="table-header">Restrictions</th>
                <th></th>
              </tr>
            </thead>
            <tbody class="table-body">
              <ng-container *ngFor="let driver of drivers$ | async; let i = index; trackBy: trackByFn">
                <!-- Main row -->
                <tr
                  class="mat-row"
                  [ngStyle]="{ 'background-color': getRowBackgroundColor(i) }"
                  (click)="driver.siteRestrictions ? toggleDetails(driver) : null"
                  [style.cursor]="driver.siteRestrictions ? 'pointer' : 'default'"
                >
                  <td class="cell">
                    <ng-container *ngIf="getSiteRestrictionsCount(driver) > 0; else noArrowRestriction">
                      <button mat-icon-button>
                        <mat-icon>{{ driver.showDetails ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
                      </button>
                    </ng-container>
                    <ng-template #noArrowRestriction>
                      <button mat-icon-button>
                        <mat-icon>horizontal_rule</mat-icon>
                      </button>
                    </ng-template>
                    {{ driver.name }}
                  </td>
                  <td class="cell">{{ driver.phone }}</td>
                  <td class="cell">{{ driver.carrier }}</td>
                  <td class="cell">{{ driver.subcarrier }}</td>
                  <td class="cell text-center">
                    <div class="flex items-center justify-center h-full">
                      <ng-container *ngIf="getSiteRestrictionsCount(driver) > 0; else noRestrictions">
                        <span class="text-red-700">Restrictions ({{ getSiteRestrictionsCount(driver) }})</span>
                      </ng-container>
                      <ng-template #noRestrictions>
                        -
                      </ng-template>
                    </div>
                  </td>
                  <td class="cell text-center">
                    <div class="flex items-center justify-center h-full">
                      <ng-container *ngIf="driver.canBeBanned; else cannotBeBanned">
                        <ng-container *saUserPermission="'ban_drivers'">
                          <button mat-flat-button color="primary" (click)="addRestriction(driver)">
                            Add Restriction
                          </button>
                        </ng-container>
                      </ng-container>
                      <ng-template #cannotBeBanned>
                        <i class="material-icons text-gray-700" [matTooltip]="'No valid CDL or phone number'">
                          do_not_disturb
                        </i>
                      </ng-template>
                    </div>
                  </td>
                </tr>
                <ng-container *ngFor="let restriction of driver.siteRestrictions">
                  <tr
                    class="mat-row"
                    *ngIf="driver.showDetails && driver.siteRestrictions"
                    [ngStyle]="{ 'background-color': getRowBackgroundColor(i) }"
                  >
                    <td class="cell">
                      <div class="flex items-start space-x-2">
                        <button
                          mat-icon-button
                          [ngClass]="{ 'hidden-icon': !restriction.isArchived }"
                          matTooltip="Site is archived"
                          class="text-gray-500 hover:text-gray-700"
                        >
                          <mat-icon>task</mat-icon>
                        </button>
                        <div class="flex-1">
                          <span class="text-gray-900 break-words">
                            {{ restriction.siteName }}
                          </span>
                        </div>
                      </div>
                    </td>

                    <td class="cell">
                      <div>
                        <p>Since {{ restriction.createdAt | date: 'longDate' }}</p>
                      </div>
                    </td>
                    <td colspan="3" class="cell">
                      <div>
                        <p>{{ restriction.banReason }}</p>
                      </div>
                    </td>
                    <td class="cell text-center">
                      <div class="flex items-center justify-center h-full">
                        <ng-container *saUserPermission="'ban_drivers'">
                          <button mat-icon-button color="warn" (click)="deleteRestriction(restriction.id)">
                            <mat-icon>delete</mat-icon>
                          </button>
                        </ng-container>
                      </div>
                    </td>
                  </tr>
                </ng-container>
              </ng-container>
            </tbody>
          </table>
        </div>
        <div class="footer">
          <mat-paginator
            (page)="switchPage($event)"
            [length]="total$ | async"
            [pageIndex]="(page$ | async) - 1"
            [pageSize]="pageSize$ | async"
            [pageSizeOptions]="[10, 25, 50]"
            #paginator
          ></mat-paginator>
        </div>
      </div>
    </div>
  </div>
</div>
